<template>
  <div class="bg_index">
    <!--banner-->
    <productBanner :Product="product" class="bannerFather"></productBanner>

    <!-- 技术亮点 -->
    <TechnicalHighlights :list="techDes">
      <h4 class>产品亮点</h4>
    </TechnicalHighlights>

    <!-- 使用场景 -->
    <suitCase :list="suit" class="suitcase1"></suitCase>

    <!-- <productBanner :Product="product2" class="bannerFather2"></productBanner> -->

    <!-- 技术亮点 -->
    <!-- <div class="w100 hxjs">
      <div class="other">
        <div v-for="(item,index) in cardMsg" :key="index">
          <coreCard :cardMsg="item"></coreCard>
        </div>
      </div>
    </div>-->

    <!-- 使用场景 -->
    <!-- <suitCase :list="suit2" class="suitcase2"></suitCase> -->

    <div style="background-color: white;">
      <!-- 下载彩页 -->
      <productDownload :product="download"></productDownload>
    </div>
    <!-- 商务合作 -->
    <cooperateForm class="submitform" id="submit"></cooperateForm>
    <div class="footblack" />
  </div>
</template>

<script>
import cooperateForm from '@/components/common/cooperateForm'
import suitCase from '@/components/common/suitCase'
import TechnicalHighlights from '@/components/common/TechnicalHighlights'
import productBanner from '@/components/common/productBanner'
import coreCard from '@/components/common/coreCard'
import productDownload from '@/components/common/productDownload'
// import { BaseURL } from '@/api/http.js'
export default {
  data () {
    return {
      download: '彩页图',
      suit: [
        { 'img': 'images/chanpin/hs_bot2.png', 'context': ['公共安全部门基于声纹库的侦查、', '布控技术手段'] },
        { 'img': 'images/chanpin/hs_bot1.png', 'context': ['智能安防、智能社区的音频监控、', '智能门禁、公共设施服务等'] }
      ],
      techDes: [
        { 'title': false, 'context': ['分布式可扩展架构', '百万级声纹库在线搜索比对', '秒级响应'], 'img': 'images/hs/cp_1.png' },
        { 'title': false, 'context': ['支持1:N、M:N、N:1、', '库间比对以及性别、', '语种辅助识别'], 'img': 'images/hs/cp_2.png' },
        { 'title': false, 'context': ['场景化的自动注册、', '自动比对特性，', '能最小化用户工作量'], 'img': 'images/hs/cp_3.png' },
        { 'title': false, 'context': ['支持麦克风、VoIP、', '移动通信、固定电话等', '各种来源调查录音'], 'img': 'images/hs/cp_4.png' },
        { 'title': false, 'context': ['提供浏览器WEB、', '移动Android 客户端', '实现高效、便捷访问'], 'img': 'images/hs/cp_5.png' }
      ],
      product: {
        'background': 'images/chanpin/hs_banner.png',
        'img': 'images/chanpin/hs_ct.png',
        'h2': ['声纹库及搜索比对系统'],
        'desc': ['面向公共安全的声纹库及搜索比对服务平台'],
        'h3': [],
        'p': ['系列—语音刻画家', '声纹辨认与音频大数据分析'],
        'product': 'images/chanpin/sj.png'
      }
    }
  },
  methods: {
  },
  components: {
    cooperateForm: cooperateForm,
    TechnicalHighlights,
    suitCase: suitCase,
    productBanner,
    coreCard,
    productDownload
  }
}
</script>

<style scoped>
/* 技术优势 */
.Technical {
  background-color: white;
}

.submitform {
  width: 803px;
  margin-top: 75px;
  margin-bottom: -23px;
}

.footblack {
  height: 50px;
  width: 100%;
  background: rgba(248, 248, 248, 1);
}
/* 产品亮点 */
.other {
  margin: 0 auto;
  width: 1250px;
  height: 650px;
}
.other > div {
  float: left;
  margin-left: 38px;
  margin-top: 35px;
}
.other /deep/ .app {
  height: 520px;
}
.other /deep/ .title {
  height: 290px;
}
/* .suitcase.cjapply[data-v-eea495be] {
    background-size: 100% 100%;
    width: 366px;
    height: 264px;
    padding-top: 105px;
    margin: 0;
} */
.suitcase /deep/ .cjapply {
  width: 526px;
}
.suitcase /deep/ #cj {
  width: 1200px;
}
.suitcase1 {
  margin-bottom: 80px;
}

.bannerFather /deep/ .caiye {
  margin-top: 50px;
}
.bannerFather /deep/ .product-h2 {
  width: 130%;
}
.bannerFather /deep/ .desc {
  width: 130%;
  margin-top: 25px;
}
.bannerFather /deep/ .product-p {
  margin-top: 105px;
}

.bannerFather /deep/ .brand {
  margin-top: -42px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/solution/Hs/SoundDetect.vue